export default {
  path: '/park/supervisionOverdue',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'overdueList',
      name: 'overdueList',
      component: () => import('@/pages/superviseContract/SuperviseContractOverdue/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管合同逾期',
      },
    },
  ],
};
